<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core'
  import { IconChevronRight } from '@gat-ship/icons'
  import {
    DropdownMenuSubTrigger,
    type DropdownMenuSubTriggerProps,
    useForwardProps
  } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = defineProps<
    DropdownMenuSubTriggerProps & {
      class?: HTMLAttributes['class']
      inset?: boolean
    }
  >()

  const delegatedProps = reactiveOmit(props, 'class', 'inset')
  const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <DropdownMenuSubTrigger
    data-slot="dropdown-menu-sub-trigger"
    v-bind="forwardedProps"
    :class="
      cn(
        'focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground outline-hidden flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm data-[inset]:pl-8',
        props.class
      )
    "
  >
    <slot />
    <icon-chevron-right class="ml-auto size-4" />
  </DropdownMenuSubTrigger>
</template>
